<template>
  <div class="container">
    <template v-if="is_login">
      <div v-if="list.length" class="content_wrap">
        <div class="record_content">
          <template v-for="(item, index) in list">
            <!-- 每日一练 -->
            <a
              v-if="item.record_type == 1"
              :key="index"
              href="JavaScript:;"
              @click="
                handleToDailyPractice(
                  item.practice_category,
                  item.practice_title,
                  item.level
                )
              "
            >
              <div class="record_wrap">
                <div class="l">
                  <div class="name">
                    每日一练（ {{ item.practice_title | filter_time
                    }}{{ item.practice_alias }} ）{{
                      item.level ? "（ " + item.level + "级 ）" : ""
                    }}
                  </div>
                  <div class="intro">
                    {{ item.create_time }}，共
                    <span>{{ item.question_nums }}</span> 题，答对<span>
                      {{ item.correct_num }}
                    </span>
                    题
                    <!-- ，正确率<span>15%</span> -->
                  </div>
                </div>
                <div v-if="!num" class="r">
                  <img src="@/assets/list/to.png" alt="" />
                </div>
              </div>
            </a>
            <!-- 课程练习 -->
            <div v-if="item.record_type == 2" :key="index" class="record_wrap">
              <div class="l">
                <div class="name">课程练习（ {{ item.practice_alias }} ）</div>
                <div class="intro">
                  {{ item.practice_title }}，共
                  <span>{{ item.practice_num }}</span> 题，答对<span>
                    {{ item.correct_num }}
                  </span>
                  题
                  <!-- ，正确率<span>15%</span> -->
                </div>
              </div>
              <div v-if="!num" class="r">
                <img src="@/assets/list/to.png" alt="" />
              </div>
            </div>
            <!-- 知识点练习 -->
            <a
              v-if="item.record_type == 3"
              :key="index"
              :href="`/know_analysis/${item.child_id}/${item.relation_id}`"
              target="_blank"
            >
              <div class="record_wrap">
                <div class="l">
                  <div class="name">
                    知识点练习（ {{ item.practice_title }} ）
                  </div>
                  <div class="intro">
                    {{ item.create_time }}，共
                    <span>{{ item.question_nums }}</span> 题，答对<span>
                      {{ item.correct_num }}
                    </span>
                    题
                  </div>
                </div>
                <div v-if="!num" class="r">
                  <img src="@/assets/list/to.png" alt="" />
                </div>
              </div>
            </a>
            <!-- 历年真题 -->
            <a
              v-if="item.record_type == 4"
              :key="index"
              :href="'/real_analysis/' + item.real_id"
              target="_blank"
            >
              <div class="record_wrap">
                <div class="l">
                  <div class="name">
                    历年真题（ {{ item.practice_title }} ）
                  </div>
                  <div class="intro">
                    {{ item.create_time }}，共
                    <span>{{ item.question_nums }}</span> 题，答对<span>
                      {{ item.correct_num }}
                    </span>
                    题 ，得分 <span>{{ item.total_score }}</span>
                  </div>
                </div>
                <div v-if="!num" class="r">
                  <img src="@/assets/list/to.png" alt="" />
                </div>
              </div>
            </a>
            <!-- 模考大赛 -->
            <a
              v-if="item.record_type == 5"
              :key="index"
              :href="
                '/mock_result/' +
                item.relation_id +
                '/' +
                item.child_class +
                '/' +
                item.child_id
              "
              target="_blank"
            >
              <div class="record_wrap">
                <div class="l">
                  <div class="name">
                    模考大赛（ {{ item.mock_title }} ——
                    {{ item.practice_alias }} ）
                  </div>
                  <div class="intro">
                    {{ item.create_time }}，共
                    <span>{{ item.question_nums }}</span> 题，答对<span>
                      {{ item.correct_num }}
                    </span>
                    题 ，得分 <span>{{ item.total_score }}</span>
                  </div>
                </div>
                <div v-if="!num" class="r">
                  <img src="@/assets/list/to.png" alt="" />
                </div>
              </div>
            </a>
            <!-- 错题关联 -->
            <a
              v-if="item.record_type == 6"
              :key="index"
              :href="`/know_analysis/${item.relation_id}/0`"
              target="_blank"
            >
              <div class="record_wrap">
                <div class="l">
                  <div class="name">
                    练习卷（ {{ item.practice_title }} ）
                  </div>
                  <div class="intro">
                    {{ item.create_time }}，共
                    <span>{{ item.question_nums }}</span> 题，答对<span>
                      {{ item.correct_num }}
                    </span>
                    题
                  </div>
                </div>
                <div v-if="!num" class="r">
                  <img src="@/assets/list/to.png" alt="" />
                </div>
              </div>
            </a>
          </template>
        </div>
        <div v-if="!num" class="page_wrap">
          <el-pagination
            @current-change="handleCurrentChange"
            @prev-click="prev_click"
            @next-click="next_click"
            layout="total, prev, pager, next, jumper"
            background
            :current-page="page"
            :page-size="limit"
            :total="total"
            :hide-on-single-page="true"
          >
          </el-pagination>
        </div>
      </div>
      <nocontent v-else />

      <el-dialog
        title="请扫码查看"
        :visible.sync="dialogTableVisible"
        width="250px"
      >
        <div class="qrCodeUrl_pop">
          <div class="qrCodeUrl" ref="qrCodeUrl" id="qrCodeUrl"></div>
        </div>
      </el-dialog>
    </template>
    <template v-else>
      <nocontent tag="login" />
    </template>
  </div>
</template>

<script>
import api from "@/request/api";
import QRCode from "qrcodejs2";
import { mapActions } from "vuex";
import nocontent from "@/components/nocontent.vue";
export default {
  components: { nocontent },
  props: { num: Number },
  data() {
    return {
      list: [],
      page: 1,
      limit: 10,
      total: 1,
      dialogTableVisible: false,
      is_login: true,
    };
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions(["setUserAndState"]),
    async getData() {
      let is_login = this.islogin();
      if (is_login) {
        let res = await api.practice_list({
          page: this.page,
          limit: this.limit,
        });
        if (res.code == 0) {
          let { data, page, count } = res.result;
          this.$emit("getTotalCount", count);
          let render_list = data;
          if (this.num) {
            render_list = data.slice(0, this.num);
          }
          this.list = render_list;
          this.total = count;
        }
      } else {
        this.is_login = false;
      }
    },
    handleCurrentChange(e) {
      this.page = e;
      this.getData();
    },
    prev_click(e) {
      this.page = e;
      this.getData();
    },
    next_click(e) {
      this.page = e;
      this.getData();
    },
    handleToDailyPractice(type, day, level) {
      this.dialogTableVisible = true;
      this.$nextTick(() => {
        document.getElementById("qrCodeUrl").innerHTML = "";
        let url = `https://h5.successkaoyan.com/dailypractice/result/${day}/${type}/${
          level ? level : 0
        }/1`;
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: url,
          width: 150,
          height: 150,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
      });
    },
    islogin() {
      this.setUserAndState();
      const { logined, user } = this.$store.state;
      if (logined) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.getData();
  },
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
.content_wrap {
  margin-top: 24px;
}
.record_content {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  box-sizing: border-box;
}
.record_wrap {
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px;
  box-sizing: border-box;
}
.record_wrap:hover {
  background: #f3f8fb;
}
.name {
  font-size: 16px;
  font-weight: bold;
  color: #1f1f1f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.intro {
  font-size: 16px;
  color: #4f5666;
  padding-top: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  span {
    color: #479dff;
  }
}
/deep/.qrCodeUrl img {
  margin: 0 auto;
}
</style>
